import { createFetchAction } from '../utils';
import * as errorTypes from './errorTypes';

export const fetchErrors = createFetchAction(errorTypes.FETCH_ERROR_LIST, 'UnHandledExceptionId');
